import {enableProdMode, TRANSLATIONS, TRANSLATIONS_FORMAT} from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { SentryService } from './app/services/sentry-service.service';

if (environment.production) {
  enableProdMode();
}

SentryService.initSentry()

// use the require method provided by webpack
declare const require;
// we use the webpack raw-loader to return the content as a string
const translationsEn = require(`raw-loader!./i18n/messages.en.xlf`).default;
const translationsPl = require(`raw-loader!./i18n/messages.pl.xlf`);

platformBrowserDynamic().bootstrapModule(AppModule, {
  providers: [
    {provide: TRANSLATIONS, useValue: translationsEn},
    {provide: TRANSLATIONS_FORMAT, useValue: 'xlf'}
  ]
}).catch(err => console.log(err));
